<template>
  <a-spin :spinning="isLoading">
    <div class="otp-verify">
      <div class="title">
        {{ $t('i18n_verify_otp') }}
      </div>
      <div class="description">
        {{ $t('i18n_verify_otp_description') }}
      </div>
      <div @keyup.enter="_handleVerify">
        <a-form-model ref="form" class="form" :rules="rules" :model="formData">
          <a-form-model-item :label="$t('i18n_otp_input')" prop="otpCode">
            <a-input
              ref="otpInput"
              v-model="formData.otpCode"
              :placeholder="$t('i18n_otp_placeholder')"
              :max-length="6"
            />
          </a-form-model-item>
          <a-button type="primary" @click="_handleVerify">
            {{ $t('i18n_confirm') }}
          </a-button>
          <div class="otp-verify__link-container">
            <div class="otp-verify__link-content">
              <router-link :to="{ name: 'Login' }">
                {{ $t('i18n_back_to_login') }}
              </router-link>
              <router-link
                :to="{
                  name: 'OtpReset',
                  params: { identityUUID: formData.identityUUID }
                }"
              >
                {{ $t('i18n_reset_otp_device') }}
              </router-link>
              <a
                href="https://support.google.com/accounts/answer/1066447?co=GENIE.Platform%3DAndroid&hl=zh-Hans&oco=0"
                target="_blank"
              >
                {{ $t('i18n_how_to_get_otp') }} ？
              </a>
            </div>
          </div>
        </a-form-model>
      </div>
    </div>
  </a-spin>
</template>

<script>
import { otp } from '@G/utils/rules'
import { getFormModelRule } from '@G/utils/other'

export default {
  name: 'OtpVerify',
  data() {
    return {
      isLoading: false,
      isError: false,
      code: '',
      formData: {
        otpCode: '',
        identityUUID: this.$route.params.identityUUID,
        type: this.$route.type,
        links: {
          resetPasswordURL: 'PasswordReset',
          resourceURL: 'Home'
        }
      },
      rules: {
        otpCode: [...getFormModelRule(otp), { validator: this._handleCheck }]
      }
    }
  },
  watch: {
    'formData.otpCode': function () {
      this.formData.otpCode = this.formData.otpCode.replace(/[^\d]/g, '')
    }
  },
  mounted() {
    this.$refs.otpInput.focus()
  },
  methods: {
    _handleVerify() {
      this.isError = false
      this.$refs.form.validate(async (error) => {
        if (error) {
          this.isLoading = true
          const {
            isError,
            code,
            toLink,
            params
          } = await this.$authProvider.otpVerify(this.formData)
          if (isError) {
            this.isError = true
            this.code = code
            this.$refs.form.validate(() => {})
          } else {
            this.$router.push({ name: toLink, params })
          }
          this.isLoading = false
        }
      })
    },
    _handleCheck(rule, value, callback) {
      if (this.isError) {
        callback(this.$t(`i18n_code_${this.code}`))
      } else {
        callback()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@THEME_VARS';

.otp-verify {
  padding-bottom: 50px;
  &__link {
    &-container {
      text-align: center;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    }
    &-content {
      text-align: left;
      display: inline-block;
      a {
        display: block;
        color: $gray4;
        margin-top: 2px;
        &::before {
          content: '\2022';
          color: $gray4;
        }
      }
    }
  }
}
</style>
